(function rsgUtmPersistence() {
  'use strict';

  var STORAGE_KEY = 'rsg_attribution_v1';
  var COOKIE_KEY = 'rsg_attribution_v1';
  var TTL_DAYS = 90;
  var PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'rsg_partner',
    'rsg_product_line',
    'rsg_tier',
    'location_id',
    'program_id',
    'rsg_order_attribution_id'
  ];

  function nowIso() {
    return new Date().toISOString();
  }

  function expiryIso() {
    return new Date(Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000).toISOString();
  }

  function isExpired(record) {
    return !record || !record.expires_at || new Date(record.expires_at).getTime() <= Date.now();
  }

  function readCookie() {
    var prefix = COOKIE_KEY + '=';
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].indexOf(prefix) === 0) {
        try {
          return JSON.parse(decodeURIComponent(parts[i].slice(prefix.length)));
        } catch (error) {
          return null;
        }
      }
    }
    return null;
  }

  function writeCookie(record) {
    var maxAge = TTL_DAYS * 24 * 60 * 60;
    document.cookie = COOKIE_KEY + '=' + encodeURIComponent(JSON.stringify(record)) +
      '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function readStored() {
    var stored = null;
    try {
      stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      stored = null;
    }

    if (!stored) {
      stored = readCookie();
    }

    if (isExpired(stored)) {
      clearStored();
      return null;
    }

    return stored;
  }

  function writeStored(record) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch (error) {
      // Cookie fallback below is enough for attribution persistence.
    }
    writeCookie(record);
  }

  function clearStored() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Ignore storage failures.
    }
    document.cookie = COOKIE_KEY + '=; path=/; max-age=0; SameSite=Lax';
  }

  function getQueryParams() {
    var urlParams = new URLSearchParams(window.location.search || '');
    var found = {};

    PARAMS.forEach(function (name) {
      var value = urlParams.get(name);
      if (value && value.trim()) {
        found[name] = value.trim();
      }
    });

    return found;
  }

  function hasKeys(object) {
    return object && Object.keys(object).length > 0;
  }

  function copyParams(params) {
    var next = {};
    Object.keys(params || {}).forEach(function (name) {
      next[name] = params[name];
    });
    return next;
  }

  function randomSegment() {
    if (window.crypto && window.crypto.getRandomValues) {
      var bytes = new Uint32Array(2);
      window.crypto.getRandomValues(bytes);
      return bytes[0].toString(36) + bytes[1].toString(36);
    }
    return Math.random().toString(36).slice(2, 14);
  }

  function generateOrderAttributionId() {
    return 'rsg-oa-' + Date.now().toString(36) + '-' + randomSegment();
  }

  function storedOrderAttributionId(record) {
    return record && (
      record.latest && record.latest.params && record.latest.params.rsg_order_attribution_id ||
      record.first && record.first.params && record.first.params.rsg_order_attribution_id
    );
  }

  function withOrderAttributionId(params, stableId) {
    var next = copyParams(params);
    if (stableId && !next.rsg_order_attribution_id) {
      next.rsg_order_attribution_id = stableId;
    }
    return next;
  }

  function touchWithOrderAttributionId(touch, stableId) {
    return {
      captured_at: touch.captured_at,
      params: withOrderAttributionId(touch.params, stableId)
    };
  }

  function captureCurrentUrl() {
    var incoming = getQueryParams();
    var stored = readStored();

    if (!hasKeys(incoming)) {
      return stored;
    }

    var stableId = incoming.rsg_order_attribution_id || storedOrderAttributionId(stored) || generateOrderAttributionId();
    incoming = withOrderAttributionId(incoming, stableId);

    var capturedAt = nowIso();
    var next = {
      version: 1,
      first: stored && stored.first ? touchWithOrderAttributionId(stored.first, stableId) : {
        captured_at: capturedAt,
        params: incoming
      },
      latest: {
        captured_at: capturedAt,
        params: incoming
      },
      expires_at: expiryIso()
    };

    writeStored(next);
    return next;
  }

  function persistedParams() {
    var stored = readStored();
    return stored && stored.latest && stored.latest.params ? stored.latest.params : {};
  }

  function isHubSpotFrame(iframe) {
    var src = iframe.getAttribute('src') || '';
    return src.indexOf('hsforms') !== -1 || src.indexOf('forms-embed') !== -1;
  }

  function appendParamsToFrame(iframe, params) {
    if (!iframe || iframe.getAttribute('data-rsg-utm-persisted') === 'true') {
      return;
    }

    if (!isHubSpotFrame(iframe) || !hasKeys(params)) {
      return;
    }

    var originalSrc = iframe.getAttribute('src') || '';
    if (!originalSrc) {
      return;
    }

    var url;
    try {
      url = new URL(originalSrc, window.location.href);
    } catch (error) {
      return;
    }

    if (!url.searchParams.get('_hsFormId')) {
      return;
    }

    var changed = false;
    Object.keys(params).forEach(function (name) {
      if (!url.searchParams.has(name) && params[name]) {
        url.searchParams.set(name, params[name]);
        changed = true;
      }
    });

    iframe.setAttribute('data-rsg-utm-persisted', 'true');

    if (changed) {
      iframe.setAttribute('src', url.toString());
    }
  }

  function fillInlineHiddenFields(params) {
    if (!hasKeys(params)) {
      return;
    }

    PARAMS.forEach(function (name) {
      var selector = [
        'input[type="hidden"][name="' + name + '"]',
        'input[type="hidden"][name$="/' + name + '"]'
      ].join(',');

      Array.prototype.forEach.call(document.querySelectorAll(selector), function (input) {
        if (!input.value && params[name]) {
          input.value = params[name];
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function syncCartAttribution(params) {
    var stableId = params && params.rsg_order_attribution_id;
    if (!stableId || !window.fetch) {
      return;
    }

    var syncKey = 'rsg_order_attribution_id:' + stableId;
    try {
      if (window.sessionStorage.getItem('rsg_order_attribution_cart_sync_v1') === syncKey) {
        return;
      }
    } catch (error) {
      // Continue without the sessionStorage guard.
    }

    window.fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          rsg_order_attribution_id: stableId
        }
      }),
      keepalive: true
    }).then(function (response) {
      if (!response.ok) {
        return;
      }
      try {
        window.sessionStorage.setItem('rsg_order_attribution_cart_sync_v1', syncKey);
      } catch (error) {
        // Ignore storage failures.
      }
    }).catch(function () {
      // Cart attribution is a best-effort join aid; do not interrupt the storefront.
    });
  }

  function inject() {
    var params = persistedParams();
    fillInlineHiddenFields(params);
    syncCartAttribution(params);
    Array.prototype.forEach.call(document.querySelectorAll('iframe'), function (iframe) {
      appendParamsToFrame(iframe, params);
    });
  }

  var injectScheduled = false;

  function scheduleInject() {
    if (injectScheduled) {
      return;
    }

    injectScheduled = true;
    window.requestAnimationFrame(function () {
      injectScheduled = false;
      inject();
    });
  }

  captureCurrentUrl();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInject);
  } else {
    scheduleInject();
  }

  var observer = new MutationObserver(function () {
    scheduleInject();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
